export function formatSportType(value) {
    const map = {
        0: 'Hockey',
        1: 'Soccer',
        Hockey: 'Hockey',
        Soccer: 'Soccer',
    };

    if (value === undefined || value === null) return 'Hockey';
    if (typeof value === 'number') return map[value] || String(value);
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (trimmed === '') return 'Hockey';
        const asNum = parseInt(trimmed, 10);
        if (!isNaN(asNum) && map[asNum]) return map[asNum];
        const key = Object.keys(map).find(k => String(k).toLowerCase() === trimmed.toLowerCase());
        if (key) return map[key];
        return trimmed;
    }
    return String(value);
}
